/* @flow */
import Column from 'components/UIKit/Flex/Column';
import Row from 'components/UIKit/Flex/Row';
import withRouting from 'utils/withRouting';

const SideNavItem = ({
  active,
  children,
  count,
  IconComponent,
  LinkComponent,
  name,
  onFilter,
  style,
}: Object): React.Element => {
  const Component = (!LinkComponent || (active && !onFilter)) ? Row
    : typeof LinkComponent === 'function' ? LinkComponent
    : props => React.cloneElement(
      LinkComponent, {
        ...props,
        style: Object.assign(
          {},
          props.style,
          LinkComponent.props.style,
        ),
      },
    );

  const bgColour = active ? '#2a72a5' : '#e5e5e5';
  const fgColour = active ? '#2a72a5' : '#333';
  return (
    <Column className="SideNav--item">
      <Component
        style={{
          fontSize: '0.9rem',
          padding: '0.5rem 1rem',
          borderLeft: `0.35rem solid ${bgColour}`,
          color: fgColour,
          ...style,
        }}
        >
        <Row style={{ alignItems: 'center', width: '100%' }}>
          {IconComponent && <IconComponent style={{ fontSize: '1.3rem', color: fgColour }} />}

          <Row
            data-testid={`row-${name}`}
            style={{
              fontWeight: IconComponent ? 'inherit' : 'bold',
              margin: '0 1rem',
              textTransform: 'capitalize',
            }}
            >
            { name || 'Unnamed Link' }
          </Row>

          {typeof count === 'number' && (
            <Row
              style={{
                color: active ? '#fff' : '#333',
                backgroundColor: bgColour,
                padding: '0 0.4rem',
                borderRadius: '0.3rem',
                fontSize: '0.75rem',
                marginLeft: 'auto',
              }}
              >
              {count}
            </Row>
          )}
        </Row>
      </Component>
      { children }
    </Column>
  );
};

export default SideNavItem;
